import { Code, Loader, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useRunLogs } from '@/api/runs';
import { brand } from '@/theme/theme';

export function RunLogs({ runId, active }: { runId: string; active: boolean }) {
  const { t } = useTranslation('runs');
  const logs = useRunLogs(runId, active);
  if (logs.isPending) return <Loader size="sm" color="forest" />;
  if (logs.isError)
    return (
      <Text fz={13} c="red">
        {t('logs.unavailable')}
      </Text>
    );
  return (
    <Code block fz={12} style={{ maxHeight: 480, overflow: 'auto' }}>
      {logs.data || <Text c={brand.textMuted}>{t('logs.empty')}</Text>}
    </Code>
  );
}
